<!-- お知らせ詳細-->
<div class="notice">
<app-notice></app-notice>
</div>